import { QueryOperation, SearchQuery } from "../code/search-query/search-query";
import { buildSearchQuery, QueryFieldMapping } from "../code/search-query/query-mapper";
import { DataColumn } from "../controls/Data.default";
import { DynamicSchema } from "../controls/DynamicForm.default";

export interface PermissionTypesViewForm {
  readonly name: string;
  readonly description: string;
}

export const permissionTypesViewColumns: DataColumn[] = [
  {
    title: "Name",
    key: "name",
    width: 192,
    sort: true,
    defaultSort: "asc",
  },
  {
    title: "Description",
    key: "description",
    width: 192,
    sort: true,
  },
  {
    title: "Created By",
    key: "createdByUserUserName",
    width: 192,
    sort: true,
    fixed: "left",
  },

  {
    title: "Created On",
    key: "createdOn",
    width: 192,
    format: "DD/MM/YYYY",
    sort: true,
  },
  {
    title: "Updated By",
    key: "updatedByUserUserName",
    width: 192,
    sort: true,
  },
  {
    title: "Updated On",
    key: "updatedOn",
    width: 192,
    format: "DD/MM/YYYY",
    sort: true,
  },
];

const permissionTypesQueryMappings: QueryFieldMapping[] = [
  { formField: "name" },
  { formField: "description", operation: QueryOperation.Contains },
];

export const mapPermissionTypesViewQuery = (values: PermissionTypesViewForm): SearchQuery =>
  buildSearchQuery(values, permissionTypesQueryMappings);

export const permissionTypesSearchSchema: DynamicSchema = {
  groups: [
    {
      controls: [
        { type: "textbox", name: "name", label: "Name" },
        { type: "textbox", name: "description", label: "Description" },
      ],
    },
  ],
};
